import { getTvObject, tv } from '@costar-ui/cosmos';
import spacingOptions from '../../../common/space-options/spacing-options.esm.js';

var segmentedControlGroupTv = getTvObject({
  base: ['flex', 'border', 'border-neutral', 'rounded-sm', 'w-full'],
  slots: {
    base: 'relative flex items-start',
    label: 'w-full border border-focus',
    subText: 'w-full'
  },
  variants: {
    gap: spacingOptions.gap,
    layout: {
      grid: {
        base: 'flex flex-col'
      },
      relative: {
        label: 'absolute -translate-y-full leading-5',
        subText: 'absolute bottom-0 translate-y-full'
      }
    },
    screenReaderOnly: {
      "true": {
        label: 'sr-only',
        subText: 'sr-only'
      }
    }
  }
});
var segmentedControlGroupStyles = tv(segmentedControlGroupTv);

export { segmentedControlGroupStyles, segmentedControlGroupTv };
//# sourceMappingURL=segmented-control-group.styles.esm.js.map
